/**
 * Here we've decided to outsource the detection of desktop/mobile for our redirect
 * to the library 'is-mobile'. At the time of writing this library is safe to use.
 * But you should always do your research and not use libraries you do not trust.
 */
import isMobileLib from 'is-mobile';
import { useMemo } from 'react';

export const useDevice = () => {
  const isMobileOrTablet = isMobileLib({ tablet: true, featureDetect: true });
  const isChromeOnAppleDevice = Boolean(navigator.userAgent.match(/CriOS/));
  const isFirefoxOnAppleDevice = Boolean(navigator.userAgent.match(/FxiOS/));
  const isOperaTouchOnAppleDevice = Boolean(navigator.userAgent.match(/OPT/));

  const deviceInfo = {
    isMobileOrTablet,
    isChromeOnAppleDevice,
    isFirefoxOnAppleDevice,
    isOperaTouchOnAppleDevice,
  };

  return useMemo(
    () => deviceInfo,
    [isMobileOrTablet, isChromeOnAppleDevice, isFirefoxOnAppleDevice, isOperaTouchOnAppleDevice],
  );
};
